
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenWeatherMetrics } from './GenWeatherMetrics';

export class GenWeatherCounty {

    category: string;
    county: string;
    dominantCategory: string;
    fips: string;
    highestMedianBurdenCategory: string;
    highestMedianBurdenCategoryAll: string;
    highestMedianBurdenValue: number;
    highestMedianBurdenValueAll: number;
    highestMedianPeakCategory: string;
    highestMedianPeakCategoryAll: string;
    highestMedianPeakValue: number;
    highestMedianPeakValueAll: number;
    longestMedianRecoveryCategory: string;
    longestMedianRecoveryCategoryAll: string;
    longestMedianRecoveryValue: number;
    longestMedianRecoveryValueAll: number;
    metrics: GenWeatherMetrics;
    outageAssociatedCategory: string;
    outageAssociatedCategoryEventCount: number;
    outageAssociatedCategoryTie: boolean;
    state: string;
    totalCustomers: number;

    constructor();
    constructor( jsonObj: any );
    constructor( genWeatherCounty: GenWeatherCounty);

    constructor( input?: GenWeatherCounty ) {
        if ( input && typeof input !== 'number' ) {
            this.category = input.category; // string [string]
            this.county = input.county; // string [string]
            this.dominantCategory = input.dominantCategory; // string [string]
            this.fips = input.fips; // string [string]
            this.highestMedianBurdenCategory = input.highestMedianBurdenCategory; // string [string]
            this.highestMedianBurdenCategoryAll = input.highestMedianBurdenCategoryAll; // string [string]
            this.highestMedianBurdenValue = input.highestMedianBurdenValue; // float [number]
            this.highestMedianBurdenValueAll = input.highestMedianBurdenValueAll; // float [number]
            this.highestMedianPeakCategory = input.highestMedianPeakCategory; // string [string]
            this.highestMedianPeakCategoryAll = input.highestMedianPeakCategoryAll; // string [string]
            this.highestMedianPeakValue = input.highestMedianPeakValue; // float [number]
            this.highestMedianPeakValueAll = input.highestMedianPeakValueAll; // float [number]
            this.longestMedianRecoveryCategory = input.longestMedianRecoveryCategory; // string [string]
            this.longestMedianRecoveryCategoryAll = input.longestMedianRecoveryCategoryAll; // string [string]
            this.longestMedianRecoveryValue = input.longestMedianRecoveryValue; // float [number]
            this.longestMedianRecoveryValueAll = input.longestMedianRecoveryValueAll; // float [number]
            if( input.metrics ) {
              this.metrics = new GenWeatherMetrics( input.metrics );
            }
            this.outageAssociatedCategory = input.outageAssociatedCategory; // string [string]
            this.outageAssociatedCategoryEventCount = input.outageAssociatedCategoryEventCount; // int [number]
            this.outageAssociatedCategoryTie = input.outageAssociatedCategoryTie; // boolean [boolean]
            this.state = input.state; // string [string]
            this.totalCustomers = input.totalCustomers; // float [number]
       }
    }

    static jsonResponseToList(arr: any[]): GenWeatherCounty[] {
        if (arr && arr.map) {
          return arr.map(a => new GenWeatherCounty(a));
        } else {
          return [];
        }
    }
}

